import {
  FormViolation,
  GlobalRouteData,
  Resource
} from '~core/models/shared.models';

export class SetRouteData {
  static readonly type = '[Global] Set Route Data';
  constructor(public payload: GlobalRouteData) {}
}

export class SetFormViolations {
  static readonly type = '[Global] Set Form Violations';
  constructor(public payload: FormViolation[] | undefined) {}
}

export class SetCurrentResource {
  static readonly type = '[Global] Set Current Resource';
  constructor(public payload: Resource | undefined) {}
}

export class ClearCurrentResource {
  static readonly type = '[Global] Clear Current Resource';
}

export class SetOnlineStatus {
  static readonly type = '[Global] Set Online Status';
  constructor(public payload: boolean) {}
}

export class CancelAction {
  static readonly type = '[Global] Cancel Action';
  constructor(public payload: string[]) {}
}
